import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDesignContext } from '@klarna/designtokens';
import { useAnimationControl } from '@bubble-ui/provider-animation-control';
import { defaultComponentTokens } from './defaultComponentTokens';
import { getDefaultStyleSheet, getKeyframes, getLoaderSize } from './utils';
export var LoaderDots = _ref => {
  var {
    inverted,
    large,
    small,
    UNSAFE_colorToken,
    UNSAFE_colorTokenArgs,
    UNSAFE_size,
    UNSAFE_strokeWidth
  } = _ref;
  var designContext = useDesignContext(defaultComponentTokens);
  var {
    disableAnimations
  } = useAnimationControl();
  var animationStyle = getKeyframes();
  var {
    svgAttrs,
    svgStyle,
    circleAttrs,
    circleStyle
  } = getDefaultStyleSheet({
    designContext,
    disableAnimations,
    inverted,
    large,
    small,
    UNSAFE_colorToken,
    UNSAFE_colorTokenArgs,
    UNSAFE_size,
    UNSAFE_strokeWidth
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    key: getLoaderSize({
      small,
      large,
      UNSAFE_size
    })
  }, svgAttrs, {
    style: svgStyle
  }), !disableAnimations && /*#__PURE__*/React.createElement("style", null, animationStyle), /*#__PURE__*/React.createElement("circle", _extends({}, circleAttrs(0), {
    style: circleStyle(0)
  })), /*#__PURE__*/React.createElement("circle", _extends({}, circleAttrs(1), {
    style: circleStyle(1)
  })), /*#__PURE__*/React.createElement("circle", _extends({}, circleAttrs(2), {
    style: circleStyle(2)
  })));
};
//# sourceMappingURL=Loader.js.map